var _filter, _filter2, _filter3, _filter4, _radialGradient, _radialGradient2, _linearGradient, _path, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 105,
    viewBox: "0 0 98 105",
    width: 98,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 103.621,
    width: 97.8224,
    x: 0.088799,
    y: 0.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_9219_2121",
    stdDeviation: 2
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 28.0371,
    width: 31.5329,
    x: 41.1182,
    y: 56.9873
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_2121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_2121",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 29.1172,
    width: 33.0783,
    x: 26,
    y: 51.9316
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_2121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_2121",
    mode: "normal",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 61.4629,
    width: 59.8881,
    x: 20.4593,
    y: 26.1553
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_2121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_2121",
    mode: "normal",
    result: "shape"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(4.11411522 36.15850057 -34.85580573 3.96589456 50.8004 51.4939)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ffc85c",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#ffc75b",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc759",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 35.4864 -49.8277 0 48.9999 52.5)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc85c",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc759",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 50.3722,
    x2: 47.2447,
    y1: 31.2213,
    y2: 60.2392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc536"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.0617 12.853 4.6268-.3491 4.6286.2658 4.5573.8765 4.4143 1.4734 4.2015 2.0471 3.9226 2.5884 3.5817 3.0889 3.1843 3.5408 2.7369 3.9367 2.2461 4.2707 1.72 4.5372 1.1668 4.7322.595 4.8525.0141 4.8965-.5672 4.863-1.1395 4.7529-1.6939 4.5679-2.2215 4.3109-2.7141 3.9858-3.1639 3.5979-3.5638 3.1532-3.9075 2.6589-4.1895 2.1225-4.4056 1.5528-4.552.9584-4.6269.3491-4.6285-.2658-4.5574-.8765-4.4142-1.4734-4.2015-2.047-3.9226-2.5884-3.5817-3.089-3.1844-3.5408-2.7368-3.9367-2.2461-4.2707-1.72-4.5372-1.1668-4.7322-.5951-4.8525-.014-4.8964.5672-4.8631 1.1395-4.7529 1.6939-4.5679 2.2215-4.3109 2.7141-3.9858 3.1638-3.5979 3.5638-3.1532 3.9075-2.6588 4.1896-2.1226 4.4055-1.5527z",
    fill: "url(#e)",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49 4.5.9917 22.8858c.0982 2.265 3.294 2.6449 3.9203.466l6.279-21.84379-4.4038 22.57669c-.433 2.2199 2.5732 3.3398 3.6981 1.3777l11.1936-19.5251-9.6129 20.8811c-.9417 2.0456 1.6912 3.8456 3.2555 2.2256l15.4831-16.0345-14.3054 17.8323c-1.4015 1.7471.6889 4.1251 2.6013 2.9591l18.8943-11.5206-18.1359 13.5688c-1.7841 1.3348-.378 4.1471 1.7603 3.5208l21.1783-6.2027-20.7908 8.3562c-2.0601.828-1.4385 3.8949.7814 3.8554l22.1231-.3927-22.0493 2.5742c-2.2036.2573-2.412 3.3763-.2623 3.9245l21.6033 5.5095-21.8286-3.336c-2.198-.3359-3.2212 2.6279-1.284 3.7194l19.6269 11.0597-20.1918-8.9449c-2.0423-.9047-3.806 1.7108-2.2017 3.265l16.3494 15.8389-17.3144-13.8938c-1.7518-1.4056-4.1332.6988-2.9538 2.6102l12.0454 19.52-13.4322-17.9183c-1.354-1.8061-4.1959-.3361-3.5041 1.8126l7.0516 21.9022-8.7988-20.8383c-.8811-2.0866-4.0056-1.3318-3.8369.9269l1.7101 22.9041-3.666-22.5302c-.3642-2.2384-3.5838-2.2384-3.948 0l-3.666 22.5302 1.7101-22.9041c.1687-2.2587-2.9558-3.0135-3.8369-.9269l-8.7988 20.8383 7.0516-21.9022c.6918-2.1487-2.1501-3.6187-3.5041-1.8126l-13.4322 17.9183 12.0454-19.52c1.1794-1.9114-1.202-4.0158-2.9538-2.6102l-17.3144 13.8938 16.3494-15.8389c1.6043-1.5542-.1594-4.1697-2.2017-3.265l-20.19182 8.9449 19.62692-11.0597c1.9372-1.0915.914-4.0553-1.284-3.7194l-21.82863 3.336 21.60343-5.5095c2.1497-.5482 1.9412-3.6672-.2624-3.9245l-22.0493-2.5742 22.1231.3927c2.2199.0395 2.8415-3.0274.7814-3.8554l-20.79084-8.3562 21.17834 6.2027c2.1383.6263 3.5443-2.186 1.7603-3.5208l-18.1359-13.5688 18.8943 11.5206c1.9124 1.166 4.0028-1.212 2.6013-2.9591l-14.3054-17.8323 15.4831 16.0345c1.5643 1.62 4.1972-.18 3.2555-2.2256l-9.6129-20.8811 11.1936 19.5251c1.1249 1.9621 4.1311.8422 3.6981-1.3777l-4.4038-22.57669 6.279 21.84379c.6263 2.1789 3.8221 1.799 3.9203-.466z",
    fill: "url(#f)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.8298 66.3496c-.4739 3.4945 3.3711 6.9712 8.5882 7.7656 5.2171.7943 9.8306-1.3946 10.3045-4.8891.0492-.3623.1926-1.443.2303-1.7897.1614-1.4838-.4848-5.6044-8.6993-6.8551-8.3339-1.2689-10.0104 3.0009-10.1697 3.9822-.0564.3479-.2055 1.428-.254 1.7861z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.1249 64.1742c.4739-3.4945 5.0874-5.6834 10.3045-4.8891 5.2171.7944 9.0622 4.2711 8.5883 7.7656-.4739 3.4944-5.0874 5.6833-10.3045 4.889s-9.0622-4.2711-8.5883-7.7655z",
    fill: "#ffc32d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.6892 70.6548c-3.8803.4348-7.9663-1.4309-9.1263-4.1671s1.0452-5.3068 4.9255-5.7415c3.8803-.4348 7.9663 1.4309 9.1264 4.1671 1.16 2.7362-1.0453 5.3068-4.9256 5.7415z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.4884 60.7462c3.8803-.4348 7.9663 1.4309 9.1264 4.1671-2.5026-.381-9.4955-1.4457-14.0519 1.5744-1.16-2.7362 1.0452-5.3068 4.9255-5.7415z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.8931 63.0638c.9141-.8864 2.3241-1.5169 4.0768-1.7133 3.8791-.4346 7.9667 1.4319 9.1264 4.1672.524 1.2359.3629 2.4367-.3303 3.4239 1.1082-1.0774 1.4855-2.5264.8488-4.0283-1.1597-2.7353-5.2473-4.6017-9.1264-4.1671-2.1263.2382-3.7514 1.1195-4.5953 2.3176z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.2552 60.2868c.0513-.1013-.0502-.2238-.2285-.2693-1.0619-.2712-2.1638-.4308-3.2539-.4709-1.2005-.044-2.3631.0579-3.4214.2999s-1.9917.6195-2.7467 1.1108c-.6856.4461-1.212.9781-1.5553 1.5706-.0576.0995.0446.2218.2212.271.1765.0493.3606.0068.4188-.0925.3185-.5444.8041-1.0334 1.435-1.4439.7004-.4557 1.5662-.8058 2.5479-1.0304.9817-.2245 2.0601-.319 3.1737-.2781 1.0031.0368 2.0171.1829 2.9949.4308.1784.0452.363.0034.4143-.098z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.3735 71.1588c-.0002.1156.1528.2254.3413.2406 2.0847.1675 4.0867-.0956 5.6922-.7481.1452-.059.1571-.1905.0314-.2896-.1256-.0991-.3412-.1283-.4867-.0695-1.4797.5971-3.3197.8389-5.2363.6882-.1885-.0149-.3417.0627-.3419.1784z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.2385 66.1089c.2294-.1173.1601-.953-.167-1.0028l-3.9208-.0025c-.2755-.042-.4399-.2366-.3134-.3712l1.6758-1.784c.2034-.2165.037-1.0341-.2737-.8753l-6.9226 3.182c-.2294.1173.1087.9939.4359 1.0437l3.8418.5849c.2755.042.4398.2366.3134.3712l-1.8657 1.1607c-.2034.2165.5007 1.1159.8113.9571z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.3177 65.5266c.2294-.1173.0811-.3706-.246-.4204l-3.8418-.5849c-.2755-.042-.4399-.2365-.3134-.3711l1.6758-1.7841c.2034-.2165-.3108-.4926-.6215-.3338l-6.3849 3.2638c-.2294.1173-.0812.3706.246.4204l3.8418.5849c.2755.042.4398.2366.3134.3712l-1.6759 1.784c-.2033.2165.3108.4926.6215.3338z",
    fill: "#ffdd28"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.1197 64.9131c.5198 3.6392 5.4341 5.8687 10.9763 4.9799s9.6136-4.5595 9.0937-8.1986c-.0539-.3774-.2178-1.5017-.2789-1.8598-.2613-1.5324-2.1018-5.4353-10.8282-4.0358-8.8533 1.4198-9.3359 6.2201-9.2166 7.2504.0423.3653.2004 1.491.2537 1.8639z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.7961 62.6471c-.5199-3.6392 3.5515-7.3098 9.0937-8.1986s10.4565 1.3407 10.9764 4.9799c.5198 3.6391-3.5516 7.3097-9.0938 8.1985-5.5422.8889-10.4564-1.3407-10.9763-4.9798z",
    fill: "#ffc32d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.4344 65.3765c-3.8279 1.6843-8.5253 1.1397-10.492-1.2163-1.9667-2.3561-.4579-5.6314 3.37-7.3157 3.8279-1.6842 8.5253-1.1396 10.492 1.2164 1.9667 2.3561.4579 5.6314-3.37 7.3156z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.3124 56.8445c3.8279-1.6842 8.5253-1.1396 10.492 1.2164-2.6585.4264-10.0872 1.6177-13.862 6.0993-1.9667-2.3561-.4579-5.6314 3.37-7.3157z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.2964 60.6377c.6768-1.1789 1.9321-2.2623 3.6612-3.0231 3.8267-1.6837 8.526-1.1389 10.492 1.2164.8884 1.0642 1.0689 2.3141.646 3.5224.8197-1.432.7883-2.9992-.2912-4.2925-1.9661-2.3553-6.6654-2.9001-10.492-1.2164-2.0976.923-3.5001 2.326-4.016 3.7932z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.0362 54.8496c.0232-.1177-.1153-.2072-.31-.1951-1.1594.0716-2.3277.2675-3.4496.5788-1.2355.343-2.3905.8193-3.3991 1.4018-1.0086.5826-1.851 1.2599-2.4792 1.9934-.5704.666-.954 1.3665-1.1336 2.0682-.0301.1179.109.207.303.1992s.3694-.1095.4001-.2273c.1682-.6458.5226-1.2902 1.0475-1.9031.5827-.6804 1.3641-1.3087 2.2997-1.849.9356-.5404 2.007-.9822 3.153-1.3003 1.0324-.2866 2.1072-.4676 3.1743-.5354.1948-.0123.3708-.1136.3939-.2312z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.2201 66.6251c.033.1154.2203.1757.4167.1301 2.1716-.5047 4.1354-1.4124 5.5835-2.5808.131-.1057.1054-.2408-.051-.2991-.1564-.0584-.3843-.018-.5157.0875-1.3359 1.0726-3.1409 1.9068-5.1364 2.3741-.1963.046-.3301.1728-.2971.2882z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.6679 60.5766c.2-.1909-.1104-1.0023-.4579-.9466l-3.9946 1.261c-.2927.047-.5159-.0942-.4257-.2692l1.1952-2.3201c.145-.2815-.259-1.0436-.5299-.785l-5.8531 5.3598c-.2.1909.1103 1.0023.4579.9466l4.0812-.6545c.2927-.047.5159.0942.4257.2693l-1.2818 1.7135c-.1451.2815.5446.9978.8155.7392z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.5811 59.9696c.2-.1909-.0236-.3958-.3712-.3401l-4.0812.6546c-.2927.0469-.5159-.0943-.4257-.2693l1.1952-2.32c.145-.2815-.458-.3914-.7289-.1328l-5.5675 5.314c-.2.1909.0237.3959.3713.3401l4.0811-.6545c.2928-.0469.516.0943.4258.2693l-1.1952 2.32c-.145.2815.4579.3913.7289.1328z",
    fill: "#ffdd28"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.299 47.3537c-.61 8.0497-6.8249 13.9588-13.8815 13.1983-7.0566-.7604-10.0692-1.6973-9.0107-15.6653 1.0355-13.6642 4.1631-14.2456 11.2197-13.4851 7.0565.7604 12.2825 7.9025 11.6725 15.9521z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.1658 60.3385c-7.0479-.7596-12.2674-7.8935-11.6582-15.934.6093-8.0405 6.8167-13.9428 13.8646-13.1832s12.2674 7.8935 11.6582 15.934c-.6093 8.0405-6.8167 13.9428-13.8646 13.1832z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.5263 42.7937c1.4137 5.5191-1.2161 11.3124-5.8737 12.9397-4.6577 1.6273-9.5795-1.5276-10.9932-7.0468-1.4137-5.5191 1.2161-11.3124 5.8738-12.9397 4.6576-1.6273 9.5794 1.5277 10.9931 7.0468z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.3179 36.5546c4.6649-1.6302 7.2799.814 8.4348 2.3874-2.7882 1.4533-9.8126 8.2764-11.6782 14.9013-5.7048-6.8961-1.4214-15.6586 3.2434-17.2887z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.5289 55.2633c-1.7225-1.3063-3.0737-3.3155-3.7123-5.8085-1.4132-5.5174 1.2176-11.313 5.8737-12.9398 2.1039-.735 4.2589-.4966 6.1237.4965-2.0934-1.5837-4.7242-2.1315-7.2808-1.2382-4.6562 1.6267-7.287 7.4224-5.8738 12.9397.7747 3.0243 2.6061 5.3412 4.8695 6.5503z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.1324 44.7815c.3057-.3369.111-.9171-.3232-.963l-5.0987-.5381c-.3656-.0386-.5822-.4728-.4131-.8282l2.2422-4.7099c.2721-.5715-1.5927-1.2483-2.0069-.792l-7.3272 9.502c-.3058.3369-.1111.9171.3231.9629l5.0987.5382c.3657.0386.5823.4728.4131.8281l-3.4514 4.9096c-.2721.5715 1.6178.9236 2.0319.4674z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.8665 44.66c.3058-.3368.1111-.917-.3231-.9629l-5.0984-.5381c-.3657-.0386-.5822-.4728-.4131-.8281l2.2421-4.7098c.2721-.5714-.4085-1.1232-.8227-.667l-8.5109 9.3767c-.3058.3368-.1111.917.3231.9629l5.0984.5381c.3656.0386.5822.4728.4131.8281l-2.2421 4.7098c-.2721.5714.4085 1.1232.8227.667z",
    fill: "#ffd83b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe77e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.9548 33.3647c.0685-.2535-.0605-.5215-.2906-.5884-1.3701-.3982-2.7943-.5213-4.2056-.3621-1.5542.1753-3.0623.6895-4.4382 1.5133-1.3758.8237-2.5925 1.9409-3.5804 3.2877-.8972 1.2229-1.5898 2.6134-2.0463 4.1053-.0767.2505.0532.518.281.5941.2277.0761.467-.068.5443-.3183.4236-1.3714 1.0625-2.6499 1.8881-3.7753.9164-1.2493 2.045-2.2855 3.3212-3.0496 1.2763-.7642 2.6751-1.2411 4.1169-1.4038 1.2987-.1465 2.6093-.0352 3.8709.3272.2303.0662.4702-.0767.5387-.3301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.1312 58.7017c-.0022.2642.1888.4811.4264.4739 2.6265-.0801 5.156-1.1258 7.1919-2.973.1842-.1671.2014-.4702.0446-.6686-.1568-.1985-.4282-.2172-.6127-.0507-1.8763 1.6926-4.2012 2.6536-6.616 2.7348-.2375.008-.4321.2194-.4342.4836z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.7834 28.7178.3256 4.327 3.3419-2.4235-2.9358 2.9723 3.8417 1.305-3.9866-.6206 1.4485 4.0508-2.0353-3.7463-2.0354 3.7463 1.4486-4.0508-3.9866.6206 3.8417-1.305-2.9359-2.9723 3.3419 2.4235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.7388 59.626.221 2.9362 2.2677-1.6445-1.9921 2.0169 2.6068.8855-2.7052-.4211.983 2.7487-1.3812-2.5421-1.3811 2.5421.9829-2.7487-2.7051.4211 2.6068-.8855-1.9922-2.0169 2.2678 1.6445z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins01);
export default __webpack_public_path__ + "static/media/coins-01.e002e6316fabcd0271dc9936f2aa15f3.svg";
export { ForwardRef as ReactComponent };